import PatientData from "./PatientData";

export default PatientData;